'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var KEYS = exports.KEYS = {
  IS_LEGITIMATE_INTEREST: 'isLegitimateInterest',
  LEGITIMATE_INTEREST_TEXT: 'legitimateInterestPrivacyPolicyText',
  LEGITIMATE_INTEREST_SUBSCRIPTIONS: 'legitimateInterestSubscriptionTypes',
  LEGITIMATE_INTEREST_LAWFUL_BASIS: 'legitimateInterestLegalBasis',
  COMMUNICATION_CONSENT_TEXT: 'communicationConsentText',
  COMMUNICATION_CONSENT_CHECKBOXES: 'communicationConsentCheckboxes',
  IMPLICIT_PROCESSING_CONSENT_TEXT: 'implicitProcessingConsentText',
  PRIVACY_POLICY_TEXT: 'privacyPolicyText'
};

var CHECKBOX_KEYS = exports.CHECKBOX_KEYS = {
  COMMUNICATION_TYPE_ID: 'communicationTypeId',
  LABEL: 'label'
};

var FORMS_KEYS = exports.FORMS_KEYS = {
  PROCESSING_CONSENT_TYPE: 'processingConsentType',
  PROCESSING_CONSENT_TEXT: 'processingConsentText'
};

var IMPLICIT_PROCESSING_CONSENT_TYPE = exports.IMPLICIT_PROCESSING_CONSENT_TYPE = 'IMPLICIT';

var GDPR_COMPLIANCE_ENABLED = exports.GDPR_COMPLIANCE_ENABLED = 'GDPRComplianceEnabled';

var LAWFUL_BASIS_PQL = exports.LAWFUL_BASIS_PQL = 'LEGITIMATE_INTEREST_PQL';

var ONE_TO_ONE = exports.ONE_TO_ONE = 'ONE_TO_ONE';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsBase/target/src/MeetingsBase/static-1.2449/js/constants/legalConsent.js
// module id = 196
// module chunks = 0